module.exports = window["plaudit"]["frontendApis"];